import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-contact/lni-retaliation-contact.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-contact/lni-retaliation-contact.module.js';

export default {
    component,
    module,
};